import React, { Component } from "react";
import { connect } from "react-redux";
import classnames from "classnames";

import { Alert } from "components/alerts/Alert";
import { Portal } from "components/general/Portal";
import Styles from "components/alerts/Alert.module.scss";

class Alerts extends Component {
  render () {
    let _attributes = {};
    _attributes.id = "gb-alerts";
    _attributes.className = Styles["alerts"];

    return (
      <Portal {..._attributes}>
        <div className={Styles["alerts__feed"]}>
          {this._renderAlerts()}
        </div>
      </Portal>
    );
  }

  // --------------------------------------------------------------------

  _renderAlerts = () => {
    const { alerts } = this.props;

    return alerts.map((item, key) => {

      return(
        <Alert key={key}
               type={item.type}
               message={item.message}
               messageId={item.id}/>
      );
    });
  };
}

const mapStateToProps = (state) => ({
  alerts: state.ui.alerts
});

const mapDispatchToProps = (dispatch) => ({
});

Alerts = connect(mapStateToProps, mapDispatchToProps)(Alerts);

export {
  Alerts
};
